import React, { useEffect, useState } from "react";
import WithAuth from "../../hoc/WithAuth";
import WarehouseTable from "../../components/tables/admin/WarehouseTable";
import { Button, Collapse, FloatButton, message, Modal, Table } from "antd";
import TableAction from "../../components/TableAction";
import { useNavigate } from "react-router-dom";
import { AuthContextValue, useAuth } from "../../providers/AuthProvider";
import FarmingStageModal from "../../components/modals/FarmingStageModal";
import {
  useDeleteFarmingStage,
  useGetFarmingStageList,
} from "../../api/farming_stage";
import { PlusOutlined } from "@ant-design/icons";

const FarmingStagePage = () => {
  const navigate = useNavigate();
  const { user } = useAuth() as AuthContextValue;
  const [tableData, setTableData] = useState<any[]>([]);

  const [selectedId, setSelectedId] = useState<number>(-1);
  const [searchText, setSearchText] = useState<string>("");
  const [deleteSelectedId, setdeleteSelectedId] = useState<number>(-1);
  const [open, setOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const { data: farmingStages, isLoading, refetch } = useGetFarmingStageList();
  const { mutateAsync: deleteFarmingStage } = useDeleteFarmingStage();

  useEffect(() => {
    if (searchText) {
      const _allData = farmingStages?.data?.data?.data.map((item: any) => {
        return {
          id: item.id,
          stageName: item.stageName,
          description: item.description,
        };
      });

      const _data = _allData.filter(
        (item: any) =>
          item.stageName?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.description?.toLowerCase().includes(searchText.toLowerCase()),
      );
      setTableData(_data);
    } else {
      if (
        farmingStages &&
        farmingStages.data &&
        farmingStages.data.data &&
        farmingStages.data.data.data
      ) {
        setTableData(farmingStages.data.data.data);
      }
    }
  }, [searchText, farmingStages]);

  const handleCreate = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
    setSelectedId(-1);
    // setSelectedStatus(undefined)
  };

  const columns = [
    {
      title: "No.",
      width: 100,
      render: (text: string, record: any, index: number) => (
        <div className="flex justify-cent font-bold">#{index + 1}</div>
      ),
    },
    {
      dataIndex: "stageName",
      title: "Stage Name",
    },
    {
      dataIndex: "description",
      title: "Description",
    },
    {
      dataIndex: "id",
      title: "Actions",
      render: (id: string, record: any, index: number) => (
        <div style={{ display: "flex", gap: 12 }}>
          <Button
            type="primary"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedId(Number(id));
              setOpen(true);
            }}
          >
            Edit
          </Button>
        </div>
      ),
    },
  ];

  const onDelete = async () => {
    if (selectedId !== -1) {
      try {
        const result = await deleteFarmingStage(selectedId);
        setDeleteOpen(false);

        if (result && result.data) {
          message.success("Farming-Stage deleted successfully.");
        }
      } catch (err: any) {
        message.error("Operation failed.");
      }
    }
  };

  useEffect(() => {
    refetch();
  }, []);

  return (
    <>
      <div
        className="hidden md:flex md:flex-col px-[50px]"
        style={{
          borderRadius: 8.5,
          marginTop: 25,
          paddingTop: 22,
          backgroundColor: "white",
        }}
      >
        <FarmingStageModal
          open={open}
          hideModal={hideModal}
          selectedId={selectedId}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: 80,
            backgroundColor: "#EEF3F8",
            borderRadius: 8.4,
            marginBottom: 12,
          }}
        >
          <TableAction
            setSearchText={setSearchText}
            onCreateNew={
              user?.roleName === "ROLE_KFT_SUPER_ADMIN"
                ? handleCreate
                : undefined
            }
          />
        </div>
        <Modal
          title={<div style={{ color: "black" }}>Confirmation</div>}
          open={deleteOpen}
          centered
          onOk={onDelete}
          onCancel={() => setDeleteOpen(false)}
          closable
          style={{ color: "black" }}
        >
          Are you sure you want to delete this farming-stage?
        </Modal>
        <Table
          style={{ cursor: "pointer" }}
          dataSource={tableData}
          columns={columns}
          loading={isLoading}
        />
      </div>
      <div className="w-full flex flex-col justify-between md:hidden">
        <div className="text-white text-2xl font-bold mb-8"></div>
        {tableData &&
          tableData.map((item: any) => {
            return (
              <Collapse
                key={item.id}
                accordion
                className="mb-1"
                items={[
                  {
                    key: item.stageName,
                    label: item.stageName,
                    children: item.description,
                  },
                ]}
              />
            );
          })}
        {user?.roleName === "ROLE_KFT_SUPER_ADMIN" && (
          <FloatButton
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleCreate}
          />
        )}
      </div>
    </>
  );
};

export default WithAuth(FarmingStagePage);
